// extracted by mini-css-extract-plugin
export default {"fr-view":"Progress_fr-view__qSX4x","course-progress":"Progress_course-progress__ILg0L","chapters":"Progress_chapters__ljy6R"};